
<template lang="html">


    <div class="container-fluid">

        <v-row>
            <v-col lg=12 cols=12 style="margin: 0 auto;">
                <v-card>
                    <v-card-title class="pa-5 pb-3 primary">
                        <v-icon class="pr-4" :color="'#FFFFFF'">mdi-clock-outline</v-icon>
                        <p style="color: white;">Cerrar Cita</p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text class="pa-5 pt-4">

                        <v-row>
                            <v-col md="6" offset-md="3">
                                <vs-list>
                                    <span style="font-weight: bold;">Estatus:</span>
                                    <vs-list-item :title="datos.ciestatus"></vs-list-item>
                                </vs-list>
                                <vs-list>
                                    <span style="font-weight: bold;">Tipo Cita:</span>
                                    <vs-list-item :title="datos.tpcnombre"></vs-list-item>
                                </vs-list>
                                <vs-list>
                                    <span style="font-weight: bold;">Fecha Inicio:</span>
                                    <vs-list-item :title="datos.fechaInicio"></vs-list-item>
                                </vs-list>
                                <vs-list v-if="datos.tpcclave==1">
                                    <span style="font-weight: bold;">Fecha Fin:</span>
                                    <vs-list-item :title="datos.fechaFin"></vs-list-item>
                                </vs-list>
                                <vs-list>
                                    <span style="font-weight: bold;">Comentarios:</span>
                                    <vs-list-item :title="datos.comentarios"></vs-list-item>
                                </vs-list>


                            </v-col>
                        </v-row>
                        <v-col md="6" offset-md="3">
                            <span style="font-weight: bold;">Cita En:</span>
                            <multiselect v-model="citaEn.cetipo"
                                         deselect-label="No se puede remover el valor seleccionado"
                                         selected-label="Seleccionado"
                                         select-label="Seleccione Cita en"
                                         track-by="cetipo" label="citaen"
                                         placeholder="Seleccione una opción"
                                         :options="citaEn.opcionesCitaEn"
                                         :allow-empty="false">
                            </multiselect>
                            <span v-if="validacetipo" class='spanError' style='color:red;font-size:11px'>Campo requerido</span>
                        </v-col>

                        <v-col md="6" offset-md="3">
                            <span style="font-weight: bold;">Concepto:</span>
                            <multiselect v-model="conceptos.ceclave"
                                         deselect-label="No se puede remover el valor seleccionado"
                                         selected-label="Seleccionado"
                                         select-label="Seleccione Concepto"
                                         track-by="ceclave" label="ceconcepto"
                                         placeholder="Seleccione una opción"
                                         :options="conceptos.opcionesConceptosCierre"
                                         :allow-empty="false"
                                         :disabled="validaConcepto">
                            </multiselect>
                            <span v-if="validaceclave" class='spanError' style='color:red;font-size:11px'>Campo requerido</span>
                        </v-col>
                        <v-row>
                            <v-col md="6" offset-md="3">
                                <span style="font-weight: bold;">Comentarios:</span>


                                <v-form ref="form"
                                        v-model="valid"
                                        lazy-validation>
                                    <v-textarea @input="uppercase()"
                                                :counter="500"
                                                maxlength="500"
                                                :rules="rulestextarea"
                                                outlined
                                                v-model="comentarios"
                                                required
                                                name="input-7-4"></v-textarea>
                                </v-form>
                            </v-col>
                        </v-row>


                        <v-row justify="center" class="mb-8">
                            <v-btn class="ma-2"
                                   color="primary"
                                   @click="CerrarCita()"
                                   :disabled="disabledSave">
                                Guardar
                            </v-btn>
                            <v-btn class="ma-2"
                                   @click="limpiarCampos()"
                                   :disabled="disabledSave">
                                Limpiar
                            </v-btn>
                            <v-btn class="ma-2"
                                   color="error"
                                   @click="Cancelar()"
                                   :disabled="disabledSave">
                                Cancelar
                            </v-btn>

                        </v-row>

                    </v-card-text>

                </v-card>
            </v-col>
        </v-row>
    </div>

    <!--</v-container>-->

</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import citas from '@/services/ControldeCitas/Citas.service.js';

    export default {
        props: {
            nrreporte: '',
            svindice: '',
            aiclave: 0,
            ciid:0
        },
        data() {
            return {
                valid: true,
                disabledSave: false,
                rulestextarea: [v => !!v || 'Campo requerido',
                    v => {
                        if (v == null) {
                            return true
                        }
                        else {
                            if (v.length < 12) {
                                return 'Mínimo 12 Carácteres'
                            }
                            else if (v.length > 500) {
                                return 'Máximo 500 Carácteres'
                            }
                            else
                                return true
                        }
                    }],
                validacetipo: false,
                validaceclave: false,
                citaEn: {
                    opcionesCitaEn: [],
                    cetipo: '',
                    citaen: ''
                },
                conceptos: {
                    opcionesConceptosCierre: [],
                    ceclave: '',
                    ceconcepto: ''
                },
                datos: {
                    ciestatus: '',
                    tpcnombre: '',
                    fechaInicio: '',
                    fechaFin: '',
                    comentarios: '',
                    tpcclave:0
                },
                validaConcepto: true,
                comentarios: '',
                counterDanger: false,
                back:0
            }
        },
        watch: {
            async 'citaEn.cetipo'(val) {
                this.validacetipo = false;

                if (val !=null || val !='') {
                    citas.obtenerConceptosCierre(this);
                    this.validaConcepto = false;
                }
            },
            async 'conceptos.ceclave'(val) {
                this.validaceclave = false;
            },
        },
        computed: {
            ...mapGetters(['getUser', 'THEME_STATE']),
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage', 'permission']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            }
        },
        methods: {
            CerrarCita() {
                this.disabledSave = true;
                this.comentarios = this.comentarios.trim();
                this.$refs.form.validate();
                let citaEn1 = this.citaEn.cetipo == '' ? 'Seleccione Cita En.</br></br>' : '';
                let conceptos1 = this.conceptos.ceclave == '' ? 'Seleccione Concepto</br></br>' : '';
                let mensajeComentario = this.comentarios.length < 12 ? 'Ingrese Comentario mínimo 12 carácteres.</br></br>' : '';


                if (this.valid == true && citaEn1 == '' && conceptos1 == '' && mensajeComentario == '')
                {
                    

                    this.$swal({
                        position: 'center',
                        title: 'Cerrando Cita, espere un momento....',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });
                    citas.guardarCerrarCita(this).then(response => {
                        this.$swal.close();

                        if (response) {

                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se cerró la cita con éxito.',
                                showConfirmButton: true,
                                timer: 3000
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.back = 1;
                                    this.limpiarCampos();
                                    this.disabledSave = false;
                                    this.$emit("cambioCerrar", false);
                                }
                            })
                            setTimeout(() => {
                                if (this.back ==0) {
                                    this.limpiarCampos();
                                    this.disabledSave = false;
                                    this.$emit("cambioCerrar", false);
                                }
                                

                            }, 3000);


                        }
                    });



                }
                else
                {
                    this.disabledSave = false;
                    if (citaEn1 != '') {
                        this.validacetipo = true;
                    }
                    if (conceptos1 != '') {
                        this.validaceclave = true;
                    }
                    
                    

                }


            },
            Cancelar() {
                this.$emit("cambioCerrar", false);
            },
            uppercase() {
                if (this.comentarios != '' && this.comentarios != null) {

                    this.comentarios = this.comentarios.toUpperCase();
                }
                
            },
            limpiarCampos() {
                this.validacetipo = false;
                this.validaceclave = false;
                this.$refs.form.reset();
                this.citaEn.cetipo = ''; 
                this.citaEn.citaen = '';
                this.conceptos.ceclave = '';
                this.citaEn.ceconcepto = '';
                this.comentarios = '';
            }

        },
        async mounted() {
            await citas.obtenerdataCitaDetalle(this).then(response => {
                this.datos.ciestatus = response[0].ciestatus;
                this.datos.tpcnombre = response[0].tpcnombre;
                this.datos.fechaInicio = response[0].fechaInicio;
                this.datos.fechaFin = response[0].fechaFin;
                this.datos.comentarios = response[0].comentarios;
                this.datos.tpcclave = response[0].tpcclave;



            });

            citas.obtenerCitaEn(this);
        }
    }
</script>

